<template>
  <div class='booking-details__dates-modal test'>
    <div class='md:grid grid-cols-12 mb-5'>
      <div class='col-span-5'>
        <h3 class='modal__title'>{{ commonChooseDate }}</h3>
        <div class='booking-details__dates-modal-subheading'>{{numberOfNights}} {{ propertyBookingsNights }}</div>
      </div>
      <div class='col-span-7 flex items-center gap-2 mt-1'>
        <theme-input
          :value='dateFromComputed'
          :isExtraInfo='true'
          :isReadonly='true'
        >
          <template slot='extra-info'>
            <i class='icon-calendar'/>
          </template>
        </theme-input>
        <theme-input
          :value='dateToComputed'
          :isExtraInfo='true'
          :isReadonly='true'
        >
          <template slot='extra-info'>
            <i class='icon-calendar'/>
          </template>
        </theme-input>
      </div>
    </div>
    <functional-calendar
      ref='Calendar'
      :configs="calendarConfigs"
      v-model='dates'
    />
    <div class='flex justify-between'>
      <span class='theme-btn theme-btn--text' @click='resetDates'>
          <i class='icon-replay' style='font-size: 20px;'></i>
          {{ commonResetDate }}
      </span>
      <span :class="['theme-btn theme-btn--theme', (!dates.dateRange.start || !dates.dateRange.end) && 'theme-btn--theme-disabled']" @click='saveDates'>{{ commonSaveAndClose }}</span>
    </div>
  </div>
</template>

<script>
  import {FunctionalCalendar} from 'vue-functional-calendar';

  export default {
    components: {FunctionalCalendar},
    data() {
      return {
        dates: {
          dateRange: {
            start: '',
            end: '',
          },
        },
        calendarConfigs: {
          dateFormat: "dd-mm-yyyy",
          limits: {
            min: moment().format("D-M-YYYY"),
            max: moment().add("10", "y").format("D-M-YYYY"),
          },
          markedDates: this.disabledDates,
          disabledDates: this.disabledDates,
          isDateRange: true,
          isModal: false,
          minSelDays: this.minDays,
          maxSelDays: this.maxDays,
          isAutoCloseable: false,
          isMultiple: true,
          calendarsCount: 2,
          monthNames: this.months,
          dayNames: this.days,
        },
      };
    },
    props: {
      selectedDate: {
        default: null,
        type: String,
      },
      range: {
        default: {},
        type: Object,
      },
      disabledDates: {
        default: [],
        type: Array,
      },
      period: {
        default: "day",
        type: String,
      },
      months: {
        default: [],
        type: [Array, Object],
      },
      days: {
        default: [],
        type: [Array, Object],
      },
      minDays: {
        default: false,
        type: [Number, Boolean],
      },
      maxDays: {
        default: false,
        type: [Number, Boolean],
      },
      commonChooseDate: {
        default: '',
        type: String,
      },
      commonResetDate: {
        default: '',
        type: String,
      },
      commonSaveAndClose: {
        default: '',
        type: String,
      },
      propertyBookingsNights: {
        default: '',
        type: String,
      },
    },
    computed: {
      dateFromComputed() {
        return this.dates.dateRange.start ? moment(this.dates.dateRange.start, 'D-M-YYYY').format('DD-MM-YYYY') : '';
      },
      dateToComputed() {
        return this.dates.dateRange.end ? moment(this.dates.dateRange.end, 'D-M-YYYY').format('DD-MM-YYYY') : '';
      },
      numberOfNights() {
        if (this.dates.dateRange.start && this.dates.dateRange.end) {
          const startDate = moment(this.dates.dateRange.start, 'DD-MM-YYYY');
          const endDate = moment(this.dates.dateRange.end, 'DD-MM-YYYY');
          return endDate.diff(startDate, 'days');
        } else {
          return '0';
        }
      },
    },
    methods: {
      resetDates: function() {
        this.dates = {
          dateRange: {
            start: '',
            end: '',
          },
        };
      },
      saveDates: function() {
        let dates = this.dates.dateRange;
        dates.start = moment(dates.start, 'DD-MM-YYYY').format('DD-MM-YYYY');
        dates.end = moment(dates.end, 'DD-MM-YYYY').format('DD-MM-YYYY');
        this.$emit('update_dates', dates);
        this.$emit('close_modal');
      },
    },
  };
</script>